import React from 'react';

import { Badge, Grid, Group, Stack, Text, px, Progress, createStyles } from '@mantine/core';
import { IconBolt, IconClock } from '@tabler/icons-react';
import HelpButton from 'components/HelpButton';
import { useDemoGymExpiration } from 'hooks/useDemoGymExpiration';
import { demoGymColors } from 'theme';
import { SessionDemoGym } from 'types/generated';

const useStyles = createStyles({
  root: {
    background: demoGymColors.bannerInnerComponentBg,
  },
});

const DemoGymCountdownBanner = ({ demoGym }: { demoGym: SessionDemoGym }): JSX.Element => {
  const { classes, theme } = useStyles();
  const { color, hoursLeft, progressPercentage } = useDemoGymExpiration(demoGym?.expiresAt || null);

  return (
    <Stack bg={demoGymColors.bannerBg} px='xl' py='sm'>
      <Grid columns={10} align='center'>
        <Grid.Col span={3}>
          <Group spacing='xs'>
            <Text fw={500} color='white'>
              You ‘re exploring Kilo in
            </Text>
            <Badge
              variant='outline'
              color='gray'
              px='xs'
              size='lg'
              bg={demoGymColors.bannerInnerComponentBg}
            >
              <Group align='center' spacing={2}>
                <IconBolt size={theme.fontSizes.xl} color={theme.colors.yellow[5]} />
                <Text fw={600} color='white' sx={{ textTransform: 'capitalize' }}>
                  Demo Mode
                </Text>
              </Group>
            </Badge>
          </Group>
        </Grid.Col>
        <Grid.Col span={7}>
          <Group position='right' align='center' spacing='md'>
            {!!demoGym?.expiresAt && (
              <>
                <Group spacing='xs'>
                  <IconClock size={px(theme.fontSizes.xl) * 1.2} color={theme.colors[color][5]} />
                  <Text color={color}>{Math.floor(hoursLeft)} Hours Left</Text>
                </Group>
                <Progress
                  color={`${color}.2`}
                  size='lg'
                  radius='xl'
                  value={progressPercentage}
                  display='flex'
                  sx={{ flexGrow: 1 }}
                  classNames={{
                    root: classes.root,
                  }}
                />
              </>
            )}

            <HelpButton actionIconProps={{ variant: 'transparent', color: theme.white, ml: 'xl' }}>
              Demo Data will not be transferred to your live account.
            </HelpButton>
          </Group>
        </Grid.Col>
      </Grid>
    </Stack>
  );
};

export default DemoGymCountdownBanner;
